import React from 'react';
import './HondaLoader.css';

/**
 * HondaLoader - Componente universal de carga para toda la aplicación
 * 
 * @param {string} message - Mensaje principal a mostrar
 * @param {string} subtitle - Subtítulo opcional (default: 'Por favor espere...')
 * @param {string} variant - Variante visual: 'fullscreen' | 'overlay' | 'inline' | 'simple'
 * @param {string} size - Tamaño: 'small' | 'medium' | 'large'
 * @param {boolean} showProgress - Mostrar barra de progreso animada
 * @param {boolean} showDots - Mostrar puntos animados
 * @param {string} className - Clases CSS adicionales
 */
const HondaLoader = ({ 
  message = 'Validando acceso...',
  subtitle = 'Por favor espere...',
  variant = 'fullscreen',
  size = 'large',
  showProgress = true,
  showDots = true,
  className = ''
}) => {
  // Determinar clases basadas en el variant
  const getContainerClasses = () => {
    switch (variant) {
      case 'fullscreen':
        return 'loader-overlay loader-fullscreen';
      case 'overlay':
        return 'loader-overlay loader-overlay-mode';
      case 'inline':
        return 'loader-inline';
      case 'simple':
        return 'loader-simple';
      default:
        return 'loader-overlay loader-fullscreen';
    }
  };

  return (
    <div className={`${getContainerClasses()} ${className}`}>
      <div className={`loader-container loader-${size}`}>
        
        <div className="spinner-wrapper">
          <div className="spinner"></div>
          <div className="spinner-inner"></div>
          
          <div className="logo-center">
            <div className="logo-box">
              <span className="logo-text">HONDA</span>
            </div>
          </div>
        </div>

        {showDots && (
          <div className="dots-container">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        )}

        {showProgress && (
          <div className="progress-container">
            <div className="progress-bar"></div>
          </div>
        )}

        <div className="message-container">
          <h3 className="message-title">{message}</h3>
          {subtitle && <p className="message-subtitle">{subtitle}</p>}
        </div>
      </div>
    </div>
  );
};

export default HondaLoader;
